// Whether the AI pays for a roll. A roll costs energy and the cost only
// rises, so the AI keeps its energy on a turn with a good move, and rolls on
// a turn with none.

import { AI_KEEP_ENERGY_GAIN } from '../constants';
import { evaluateFor } from '../engine/evaluate';
import { canPayForRoll, type GameState } from '../game/state';

/** What the best move wins for the side to move: its score from the search, less the board as it stands. */
export const moveGain = (state: GameState, score: number): number =>
  score - evaluateFor(state.board, state.turn);

/** The side can pay for a roll, and its best move does not win enough to go without one. */
export const paysForRoll = (state: GameState, score: number): boolean =>
  canPayForRoll(state) && moveGain(state, score) < AI_KEEP_ENERGY_GAIN;
